var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-page"},[_c('div',{staticClass:"error-img"}),_c('div',{staticClass:"error-box"},[_c('h4',[_vm._v("404")]),_c('div',{staticClass:"msg"},[_vm._v("抱歉您访问的页面不存在")]),_c('div',[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.goHome}},[_vm._v("返回首页")])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }